'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoSocialHtml5Outline = function IoSocialHtml5Outline(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm5 2.5h30l-2.7 31.5-12.3 3.5-12.3-3.5z m24.9 29.6l2.4-27.1h-24.6l2.4 27.1 9.9 2.8z m-18.3-11.5l-1.1-11.7h18.9l-0.3 3.9h-14.4l0.3 4h13.8l-1.1 11.8-7.7 2.2-7.7-2.2-0.5-6h3.7l0.3 3 4.2 1.2 4.1-1.2 0.5-5h-13z' })
        )
    );
};

exports.default = IoSocialHtml5Outline;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/social-html5-outline.js
// module id = 2685
// module chunks = 0